/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useCallback } from 'react';
import NewTable from '../../components/NewTable/NewTable';
import { TbEdit } from "react-icons/tb";
import { useDispatch, useSelector } from 'react-redux';
import { alertActions, userManagementActions } from '../../_actions';
import UpdateModal from './Components/UpdateModal';
import Pagination from '../../components/Pagination/Pagination';
import Loader from '../../components/Atoms/Loader';
import useDebounce from '../../Custom Hooks/Debounce';

const MerchantCharges = () => {
  const dispatch = useDispatch();
  const { userManagement } = useSelector(state => state) || {};
  const { getMerchantWebStoreChargeList = [], getMerchantWebStoreChargeTotal, loading } = userManagement || {};

  // State management
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('ALL');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const size = 10
  const [pageNo, setPageNo] = useState(1)

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingField, setEditingField] = useState(null);
  const [currentValue, setCurrentValue] = useState('');
  const [currentItem, setCurrentItem] = useState(null);
  const debounce = useDebounce(searchTerm, 500)

  const apiPayload = {
    keyWord: debounce,
    fromDate: fromDate,
    toDate: toDate,
    sortBy: "createdAt",
    sortOrder: "desc",
    pageNo: pageNo,
    size: size
  };

  useEffect(() => {
    fetchCharges();
  }, [dispatch, debounce, pageNo, size, sortBy]);

  const fetchCharges = useCallback(() => {
    dispatch(userManagementActions.getMerchantWebStoreChargeList(apiPayload));
  }, [dispatch, apiPayload]);

  const handleEditClick = useCallback((item, field) => {
    setCurrentItem(item);
    setEditingField(field);
    setCurrentValue(field === 'fee' ? item.redeemFee : item.holdDay);
    setIsModalOpen(true);
  }, []);

  const handleModalSubmit = useCallback((submittedValue) => {
    if (!currentItem || !editingField) return;

    const updatePayload = {
      ...apiPayload,
      id: currentItem._id,
      [editingField === 'fee' ? 'redeemFee' : 'holdDay']: submittedValue
    };

    userManagementActions.updateMerchantWebStoreCharge(updatePayload)
      .then((res) => {
        dispatch(alertActions.success(res?.message))
        fetchCharges();
        setIsModalOpen(false);
      })
      .catch(error => {
        dispatch(alertActions.error(error))
      });
  }, [currentItem, editingField, dispatch, apiPayload, fetchCharges]);


  const sortingOptions = [
    { value: 'ALL', label: 'Sort by All' },
    { value: 'pending', label: 'Sort by Pending' },
    { value: 'completed', label: 'Sort by Completed' },
    { value: 'failed', label: 'Sort by Failed' },
    { value: 'rejected', label: 'Sort by Rejected' },
  ];

  const tableHeadings = ['Owned By', 'Shop Name', 'Shop URL', 'Fees', 'Hold Days'];


  const tableRows = getMerchantWebStoreChargeList?.map((ele) => [
    <span className="underline" key={`name-${ele._id}`}>
      {ele?.userId?.name}
    </span>,
    <span
      className="truncate max-w-[200px] inline-block"
      title={ele?.storeName}
    >
      {ele?.storeName}
    </span>,
    <span
      className="truncate max-w-[200px] inline-block"
      title={ele?.storeURL}
    >
      {ele?.storeURL}
    </span>,
    <div className="flex justify-between items-center" key={`fee-${ele._id}`}>
      <span>{ele?.redeemFee}%</span>
      <button
        className="text-blue-600 hover:text-blue-800 transition-colors"
        onClick={() => handleEditClick(ele, 'fee')}
        aria-label="Edit fee"
      >
        <TbEdit size={20} />
      </button>
    </div>,
    <div className="flex justify-between items-center" key={`hold-${ele._id}`}>
      <span>{ele?.holdDay} days</span>
      <button
        className="text-blue-600 hover:text-blue-800 transition-colors"
        onClick={() => handleEditClick(ele, 'holdDay')}
        aria-label="Edit hold days"
      >
        <TbEdit size={20} />
      </button>
    </div>,
  ]);

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingField(null);
    setCurrentValue('');
    setCurrentItem(null);
  };

  const onPageChange = (page) => {
    setPageNo(page)
  }

  return (
    <div className="p-4 h-full overflow-auto">
      <Loader loading={loading} />
      <NewTable
        Heading={`Merchants Charges (${getMerchantWebStoreChargeTotal})`}
        tableHeadings={tableHeadings}
        data={tableRows}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearch={true}
        placeholder="Search by shop name"
        // summaryDataFull={getMerchantWebStoreChargeTotal}
        showSorting={false}
        onSortByStatus={(e) => setSortBy(e.target.value)}
        sortStatusValue={sortBy}
        sortingOptions={sortingOptions}
        fromDate={fromDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        toDate={toDate}
        showDateFilter={false}
        showPageTopData1={false}
        showPageTopData2={false}
        showPageTopData3={false}
        showPageTopData4={false}


      />

      <UpdateModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onConfirm={handleModalSubmit}
        editingField={editingField}
        currentValue={currentValue}
        setCurrentValue={setCurrentValue}
      />



      {Math.ceil(getMerchantWebStoreChargeTotal / size) > 1 && (
        <Pagination
          totalPages={Math.ceil(
            getMerchantWebStoreChargeTotal / size
          )}
          currentPage={pageNo}
          onPageChange={onPageChange}
        />
      )}


    </div>
  );
};

export default MerchantCharges;